export default {
  defaultKpiName: 'Sales',
  linkCopied: 'Link copied to clipboard!',
  kpi: 'KPI',
  sharePlan: 'Share Plan',
  share: 'Share',
  sharingDisabled: 'Sharing disabled',
  sharingEnabled: 'Sharing enabled',
  creatingLink: 'Creating Link...',
  done: 'Done',
  budget: 'Budget',
  upTo: 'up to {value}',
  restrictions: 'Restrictions',
  spendIn: 'Spend in',
  and: 'and',
  predictedSales: 'Predicted {kpi}',
  fullPeriodSummary: 'Full Period Summary',
  monthlyDetailView: 'Monthly Detail View',
  weeklyDetailView: 'Weekly Detail View',
  touchpoints: 'Touchpoints',
  segments: 'Segments',
  admin: 'Admin',
  mediaSpendCalendar: 'Media Spend Calendar',
  rawOutput: 'RAW Output',
  injectChanges: 'Inject changes',
  // Names used by the Admin tab's hidden-sections list for parts that have no title of their own
  hiddenGroupHeader: 'Header',
  hiddenGroupTabs: 'Tabs',
  kpiSelector: 'KPI selector',
  totalKpiOption: '"Total" KPI option',
  kpiOption: '"{kpi}" KPI option',
  restrictionsChip: 'Restrictions chip',
  precisionChip: 'Prediction precision chip',
  roasByChannel: 'ROAS by Channel',
  planSpendDatapoints: 'Plan spend datapoints on the curves',
  segmentsSpendDetail: 'Spend by Segment',
  salesByMicroaudience: '{kpi} by Microaudience',
  loading: 'Loading...',
  unrestricted: 'Unrestricted',
  moreThan: 'More than',
  lessThan: 'Less than',
  between: 'Between',
  exactly: 'Exactly',
  betaOptimizerTooltip: 'This plan uses the new optimizer (beta)',
  // XLSX download
  xlsxPlan: 'Plan',
  xlsxFirstValue: 'First value',
  xlsxSecondValue: 'Second value',
  xlsxShareOfBudget: 'Share of budget',
  xlsxTouchpoint: 'Touchpoint',
  xlsxVariability: 'Variability',
  xlsxTotal: 'Total',
  spendByTouchpoint: 'Spend by Touchpoint',
  spendBySegment: 'Spend by Segment',
  mediaKpiBySegment: 'Media {kpi} by Segment',
  microaudienceContribution: 'KPI Contribution by Microaudience'
}
